import "./lyComparison.css";

export type LyComparison = "same_date" | "same_weekday";
export const normalizeLyComparison = (value: unknown): LyComparison => value === "same_weekday" ? "same_weekday" : "same_date";
const copy = {
  tr: ["LY karşılaştırması", "Aynı tarih", "Aynı hafta/gün", "52 hafta önceki aynı günler"],
  en: ["LY comparison", "Same dates", "Same weekdays", "Matching days 52 weeks earlier"],
  ru: ["Сравнение LY", "Те же даты", "Те же дни недели", "Те же дни 52 недели назад"],
  uz: ["LY taqqoslash", "Bir xil sana", "Bir xil hafta kuni", "52 hafta oldingi mos kunlar"],
};
export function lyComparisonLabel(mode: LyComparison, language: string) {
  return (copy[language as keyof typeof copy] ?? copy.tr)[mode === "same_weekday" ? 2 : 1];
}
export function LyComparisonControl({ value, language, disabled, onChange, compact = false }: {
  value: LyComparison; language: string; disabled: boolean; onChange: (mode: LyComparison) => void; compact?: boolean;
}) {
  const c = copy[language as keyof typeof copy] ?? copy.tr;
  return <div className="ly-comparison-control">
    <strong>{compact ? "LY" : c[0]}</strong>
    <div role="group" aria-label={c[0]}>
      {(["same_date", "same_weekday"] as const).map((mode, index) =>
        <button key={mode} type="button" aria-pressed={value === mode} disabled={disabled}
          title={mode === "same_weekday" ? c[3] : c[1]} onClick={() => onChange(mode)}>{c[index + 1]}</button>)}
    </div>
  </div>;
}
